import { StringConst, NumberCons, BooleanCons } from '../../constants/const';
import { BaseResponseHttp } from '../http/commons.model';
import { IProducts, ShoppingTab, TypeShoppingCar } from '../http/myActivity.model';
import { CartContentType } from '../http/shoppingList';
export class UpdateProduct {
    userId: string;
    itemCode: string;
    quantity: number;
    container: string;
    label: string;
    needsPersitance: boolean;
    cartType: number;
    needSumQuantity: boolean;
    needsFavorite: boolean;
    isLine: string | null;
    isPackage: boolean;
    needContainerValidation: boolean;
    containerToReplace: string;
    priceListId: number;
    constructor() {
        this.userId = StringConst.empty;
        this.itemCode = StringConst.empty;
        this.quantity = NumberCons.zero;
        this.container = StringConst.empty;
        this.label = StringConst.empty;
        this.needsPersitance = false;
        this.cartType = 0;
        this.needSumQuantity = false;
        this.needsFavorite = false;
        this.isLine = null;
        this.isPackage = false;
        this.needContainerValidation = false;
        this.containerToReplace = StringConst.empty;
        this.priceListId = NumberCons.one;
    }
}

export class DeleteProduct {
    userId: string;
    itemCode: string;
    cartType: number;
    label: string;
    container: string;
    constructor() {
        this.userId = StringConst.empty;
        this.itemCode = StringConst.empty;
        this.cartType = NumberCons.zero;
        this.label = StringConst.empty;
        this.container = StringConst.empty;
    }
}
export class UpdateProductUtility {
    itemCode: string;
    priceToPublic: number;
    needSaveQuantity: boolean;
    quantity: number;
    constructor() {
        this.itemCode = StringConst.empty;
        this.priceToPublic = NumberCons.zero;
        this.needSaveQuantity = false;
        this.quantity = NumberCons.zero;
    }
}

export class ReloadShoppingCar {
    typeCart = TypeShoppingCar.default;
    index = NumberCons.zero;
    needChangeTab = BooleanCons.false;
}

export class ChangeShoppingTab {
    tab = ShoppingTab.shoppingCart;
}
export class ChangeProductQuantityOrders {
    allShopCartWasDeleted: boolean;
    constructor() {
        this.allShopCartWasDeleted = BooleanCons.false;
    }
}
export interface ChangeProductQuantityOrdersResponse extends BaseResponseHttp {
    response: ChangeProductQuantityOrders;
}

export class ShopingCartPrices {
    totalProducts: number;
    totalPieces: number;
    subTotal: number;
    tax: number;
    amountTotal: number;
    discount: number;
    hasDiscountSpecial: boolean;
    percentDiscountSpecial: number;
    totalOfUtilities: number;
    shippingCost: number;
    cartContentType: CartContentType;
    items: IProducts[];
    discountMessages: string[];
    typeOrder: string;
    promotionalCodeAmount: number;
    constructor() {
        this.totalProducts = NumberCons.zero;
        this.totalPieces = NumberCons.zero;
        this.subTotal = NumberCons.zero;
        this.tax = NumberCons.zero;
        this.amountTotal = NumberCons.zero;
        this.discount = NumberCons.zero;
        this.hasDiscountSpecial = BooleanCons.false;
        this.percentDiscountSpecial = NumberCons.zero;
        this.totalOfUtilities = NumberCons.zero;
        this.shippingCost = NumberCons.zero;
        this.cartContentType = CartContentType.default;
        this.items = [];
        this.discountMessages = [];
        this.typeOrder = StringConst.empty;
        this.promotionalCodeAmount = NumberCons.zero;
    }
}

export interface ShopingCartUpdatedPricesResponse extends BaseResponseHttp {
    response: ShopingCartPrices;
}

export interface ErrorMinMaxMessage {
    min: string;
    max: string;
    minMax: string;
}

export interface CartFilters {
    [key: string]: string;
}
